import { UsuarioUpdate } from './../entities/usuarioUpdate.entity';
import { UsuarioOnline } from './../entities/UsuarioOnline.entity';
import { Component, OnInit } from '@angular/core';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import { validate, ValidationError } from 'class-validator';
import { UsuarioValidate } from '../entities/usuarioValidate.entity';
import { AlertBoxComponent } from '../shared/alertbox.component';
import { CodTelefono, FormatoTelefono, Naciones } from '../entities/naciones';
import { UserServiceA2P } from '../services/userA2P.service';
import { HttpService } from '../services/http.service';

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html'
})
export class UsuarioComponent implements OnInit {
  public nombre: string;
  public login: string;
  public email: string;
  public codigoTelefono: string = CodTelefono.COD_TELEFONO_DEFAULT;
  public codigoTelefono2: string = CodTelefono.COD_TELEFONO_DEFAULT;
  public telefono1: string;
  public telefono2: string;
  public oldPassword: string;
  public password: string;
  public passwordConfirm: string;
  public efactura: boolean;
  public avisoEmail: string;
  public inputErrorNombre = false;
  public inputErrorEmail = false;
  public inputErrorTelefono1 = false;
  public inputErrorTelefono2 = false;
  public inputErrorPass: boolean;
  public inputErrorOldPass: boolean;
  public user: UsuarioUpdate;
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;
  public factText = 'factura';
  public codigosTelefono: Naciones[];
  public showModalValidCod: boolean = false;
  private usuarioOnline : UsuarioOnline;
  public explotacionActual:string;

  constructor(private userService: UserService, private sessionService: SessionService,
    private router: Router,private userServiceA2P : UserServiceA2P,private httpService: HttpService) { }

  ngOnInit() {
    if (this.sessionService.isAuthenticated) {
      if (this.sessionService.datosExplotacion.Codigo.toUpperCase() === 'MELILLA') {
        this.factText = 'pre-factura';
      }
      this.getNaciones();

      let telefono1 = this.formatearNumeroTelefono(this.sessionService.telefono);
      let telefono2 = this.formatearNumeroTelefono(this.sessionService.telefono2);

      this.nombre = this.sessionService.nombre;
      this.login = this.sessionService.login;
      this.email = this.sessionService.email;
      this.codigoTelefono = telefono1 && telefono1.CodigoTelefono != null ? telefono1.CodigoTelefono : CodTelefono.COD_TELEFONO_DEFAULT;
      this.codigoTelefono2 = telefono2.CodigoTelefono;
      this.telefono1 = telefono1.Numero
      this.telefono2 = telefono2.Numero;
      this.efactura = this.sessionService.efactura;
      this.avisoEmail = 'Atención!!! La respuesta a su solicitud puede recibirla en la carpeta de correo no deseado. ' +
        'En el caso de cuentas de correo de Hotmail, vemos necesario añadir previamente a sus contactos la cuenta ' +
        this.sessionService.datosExplotacion.Email + ' para asegurarse de que recibirá nuestros correos.';
      this.explotacionActual = this.sessionService.datosExplotacion.Codigo;
    } else {
      this.router.navigate(['/public/login']);
    }
  }

  private formatearNumeroTelefono(telefono: string): FormatoTelefono {
    let telefonoFormat = new FormatoTelefono;
    const regexSoloNumero = /^\d+$/;
    if(!telefono || telefono.trim().length === 0) 
      return telefonoFormat;
    
    if (regexSoloNumero.test(telefono))
      telefonoFormat.Numero = telefono;
    else{
      const partes = telefono.split('-');
      telefonoFormat.CodigoTelefono = partes[0];
      telefonoFormat.Numero = partes[1];
    }

    return telefonoFormat;
  }
  
  public clearInputErrors() {
    this.inputErrorNombre = false;
    this.inputErrorEmail = false;
    this.inputErrorTelefono1 = false;
    this.inputErrorTelefono2 = false;
    this.inputErrorPass = false;
    this.inputErrorOldPass = false;
    this.messageCabecera = '';
    this.messageComplet = '';
    this.typeException = -1;
  }

  public showErrors(resultado: ValidationError[]) {
    for (const item of resultado) {
      switch (item.property) {
        case 'Nombre':
          this.inputErrorNombre = true;
          break;
        case 'EMail':
          this.inputErrorEmail = true;
          break;
        case 'Telefono1':
          this.inputErrorTelefono1 = true;
          break;
        case 'Telefono2':
          this.inputErrorTelefono2 = true;
          break;
      }
    }
  }

  public actualizarUsuario() {
    this.clearInputErrors();
    this.usuarioOnline = new UsuarioOnline;
    let valCod : Boolean = false;

    this.usuarioOnline = { ...this.sessionService.usuario };
    this.usuarioOnline.Nombre = this.nombre;
    this.usuarioOnline.EMail = this.email;

    const tel = (this.usuarioOnline && this.usuarioOnline.Telefono1 || '').trim();
    const [codigo, numero] = tel.split('-', 2).map(p => (p ? p.trim() : ''));
 
    valCod =  !!this.sessionService.validacionA2P &&
              !!(this.codigoTelefono && this.codigoTelefono.trim()) &&
              !!(this.telefono1 && this.telefono1.trim()) &&
              this.telefono1.trim() !== '0' && (
                codigo !== (this.codigoTelefono ? this.codigoTelefono.trim() : '') ||
                numero !== (this.telefono1 ? this.telefono1.trim() : '')
              );

    
    if (this.telefono1 && this.telefono1 !== '0') {
      this.usuarioOnline.Telefono1 = this.codigoTelefono
        ? `${this.codigoTelefono}-${this.telefono1}`
        : this.telefono1;
    }

    if (this.telefono2 && this.telefono2 !== '0') {
      this.usuarioOnline.Telefono2 = this.codigoTelefono2
        ? `${this.codigoTelefono2}-${this.telefono2}`
        : this.telefono2;
    }

    if (this.codigoTelefono2 && this.telefono2 && this.telefono2 !== '0') {
      this.usuarioOnline.Telefono2 = this.codigoTelefono2 + '-' + this.telefono2;
    }  

    this.usuarioOnline.EFactura = this.efactura;
    this.usuarioOnline.Password = this.password;
    this.user = new UsuarioUpdate;
    this.user.UsuarioOnline =  this.usuarioOnline;
    this.user.cambioPassword = false;
    this.password = this.password === undefined ? '' : this.password;
    this.passwordConfirm = this.passwordConfirm === undefined ? '' : this.passwordConfirm;
    this.oldPassword = this.oldPassword === undefined ? '' : this.oldPassword;
    this.user.passwordRepetir = this.passwordConfirm;
    this.user.oldPassword = this.oldPassword;
    this.inputErrorPass = false;
    this.inputErrorOldPass = false;
    if (this.password !== '' || this.passwordConfirm !== '') {
      if (this.password === this.passwordConfirm) {
        this.user.cambioPassword = true;
      } else {
        this.inputErrorPass = true;
      }
    } else if (this.oldPassword !== '') {
      this.inputErrorPass = true;
    }
    if ((this.password !== '' || this.passwordConfirm !== '') && this.oldPassword === '') {
      this.inputErrorOldPass = true;
    }
    if(document.getElementById('top') !== null)    
        document.getElementById('top').scrollIntoView();

    if (this.updateUser()) {
      validate(this.cargarDatosValidate(this.usuarioOnline)).then(resultado => {
          if (resultado.length > 0) {
              this.showErrors(resultado);
          } else {
            if(valCod){
                   this.enviarCodSMS();
            } else {
              this.userService.updateuser(this.sessionService.explotacion, this.user).subscribe(() => {
                      return this.updateuserOnSuccess(this.usuarioOnline);
                    },
                    response => this.updateuserOnError(response));
            }
        }
      });
        
    } else if (this.password !== '' && this.passwordConfirm !== '' && this.oldPassword !== '' &&
        !this.inputErrorPass && !this.inputErrorOldPass) {
          if(valCod){
                this.enviarCodSMS();
            } else {
              this.userService.updateuser(this.sessionService.explotacion, this.user).subscribe(() => {
                return this.updateuserOnSuccess(this.usuarioOnline);
              },
              response => this.updateuserOnError(response));
            }
    }  
    
  }
  
  public async onSubmitModalCod() 
  {
    this.showModalValidCod = false;   
     this.userService.updateuser(this.sessionService.explotacion, this.user).subscribe(() => {
                      return this.updateuserOnSuccess(this.usuarioOnline);
                    },
                    response => this.updateuserOnError(response));
  }
    
  public closeModal() {
     this.showModalValidCod = false;  
  }
    
  public updateuserOnSuccess(usuarioOnline: UsuarioOnline) {
    this.messageCabecera = 'Datos actualizados correctamente';
    this.messageComplet = 'Sus datos han sido actualizados correctamente';
    this.typeException = 2;
    AlertBoxComponent.changeMensaje.next(this.typeException);
    this.sessionService.efactura = this.efactura;
    this.sessionService.usuario = usuarioOnline;
    this.sessionService.nombre = this.nombre;
    this.sessionService.email = this.email;
    this.sessionService.telefono = this.codigoTelefono + '-' + this.telefono1;
    this.sessionService.telefono2 = this.codigoTelefono2 + '-' + this.telefono2;
    this.cleanPassInputs();    
    this.httpService.hideSpinner();    
  }

  public updateuserOnError(response: any) {
    this.messageCabecera = 'Datos no actualizados';
    if (response.Ex) {
      this.messageComplet = response.Ex.Message;
    }
    if (response.TipoExcepcion >= 0) {
      this.typeException = response.TipoExcepcion;
    }
    AlertBoxComponent.changeMensaje.next(this.typeException);
    this.httpService.hideSpinner();
  }

  public cargarDatosValidate(usuario: UsuarioOnline): UsuarioValidate {
    const usuarioValidate = new UsuarioValidate();
    usuarioValidate.EMail = usuario.EMail;
    usuarioValidate.Nombre = usuario.Nombre;
    usuarioValidate.Telefono1 = usuario.Telefono1;
    usuarioValidate.Telefono2 = usuario.Telefono2;
    return usuarioValidate;
  }

  public updateUser(): boolean {
    if (this.nombre !== this.sessionService.nombre || this.email !== this.sessionService.email
      || this.codigoTelefono + '-' + this.telefono1 !== this.sessionService.telefono || this.codigoTelefono2 + '-' + this.telefono2 !== this.sessionService.telefono2) {
      return true;
    } else {
      return false;
    }
  }

  public cleanPassInputs() {
    this.oldPassword = '';
    this.password = '';
    this.passwordConfirm = '';
  }

  
  public enviarCodSMS(){
    this.userServiceA2P.enviarCodSMS(this.usuarioOnline.Telefono1).subscribe(
          () => {  this.showModalValidCod = true },
            response => this.updateuserOnError(response)
    );
  }
  
 public reSendCode(){
    this.enviarCodSMS();
 }
      /**
     * Obtiene la lista de códigos de teléfono por país.
     * @param {string} explotacion - Código de explotación.
     * @returns {Observable<any>} - Un observable que contiene la lista de naciones para la explotación especificada.
     */
      private getNaciones(){
        this.userService.getNaciones(this.sessionService.explotacion).subscribe(
          data => {
            this.codigosTelefono = data;
          },
          error => {
            this.messageCabecera = 'Error';
            this.messageComplet = 'Error al obtener los códigos de teléfono';
            this.typeException = 1;
          }
        );
      }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/usuario.component.ts